import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=130f2cf0&scoped=true&"
import script from "./Plan.vue?vue&type=script&lang=js&"
export * from "./Plan.vue?vue&type=script&lang=js&"
import style0 from "./Plan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Plan.vue?vue&type=style&index=1&id=130f2cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f2cf0",
  null
  
)

export default component.exports